<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backrekapabsen">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Detail Absensi</div>
                <div class="header-top--right">
                    <div class="header-item">
                        <!-- <img src="../../assets/icons/search.svg" alt=""> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">

            <div class="w-limit">
                <div class="p-x-20 p-y-16">
                    <div class="wrapper">
                        <div class="form-label">Tanggal</div>
                        <div class="f-16">{{Date_rekap}}</div>
                    </div>
                    <div class="d-flex-between-center m-t-16">
                        <div class="wrapper">
                            <div class="form-label">Status</div>
                            <div class="f-16" v-if="status==='0'">Tanpa Status</div>
                            <div class="f-16" v-if="status==='1'">Masuk Kerja</div>
                            <div class="f-16" v-if="status==='2'">Alpha</div>
                            <div class="f-16" v-if="status==='3'">Cuti</div>
                            <div class="f-16" v-if="status==='4'">Sakit</div>
                        </div>
                        <button class="btn btn-outline-small" data-toggle="modal" data-target="#modalnotif">Ubah Status
                        </button>
                    </div>
                </div>
                <div class="separator-line"></div>
                <div class="p-x-20 p-y-16 container jam-kerja-wrapper">
                    <div class="row">
                        <div class="col">
                            <div class="form-label">Masuk</div>
                            <div class="f-16">Pukul {{masuk_kerja}}</div>
                        </div>
                        <div class="col">
                            <div class="form-label">Pulang</div>
                            <div class="f-16">Pukul {{pulang_kerja}}</div>
                        </div>
                    </div>
                </div>
                <div class="p-x-20 p-y-16 tanpa-status-wrapper" id="tanpa_status">
                    <div class="f-14 f-c-midgrey">
                        ‘Tanpa status’ merupakan status yang diberikan jika karyawan tidak melakukan absen. Anda bisa
                        mengubahnya.
                    </div>
                </div>

            </div>

            <div class="nav-bottom-wrapper">
                <div class="p-x-20 absensi-noted-by" style="">
                    Dicatat dari <b> Smartlink Karyawan</b>
                </div>
                <div class="p-x-20 p-y-12 d-flex-between-center w-limit">
                    <button class="btn btn-outline-small btn-icon"  @click="buttonKemarin">
                        <div class="m-r-4 icon-16 icon-left-blue"></div>
                        Kemarin
                    </button>
                    <button class="btn btn-outline-small btn-icon"  @click="buttonBesok">
                        Besok
                        <div class="m-l-4 icon-16 icon-right-blue"></div>
                    </button>
                </div>
            </div>
        </div>

        <!-- MODAL -->
        <div class="modal fade" id="modalnotif" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <h5 class="f-16 f-bold">Ubah Status Absensi</h5>
                        <div class="modal-head--right" data-dismiss="modal">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">

                        <div class="form-group mod m-t-16">
                            <label for="exampleFormControlSelect1" class="form-label">Status</label>
                            <select class="form-control right-icon icon-dropdown" id="exampleFormControlSelect1"
                                    v-model="selectedabsen" @change="cekvalidatemodal">
                                <option value="" selected>Pilih Status</option>
                                <option value="1">Masuk Kerja</option>
                                <option value="2">Alpha</option>
                                <option value="3">Cuti</option>
                                <option value="4">Sakit</option>
                                <option value="0">Tanpa Status</option>
                            </select>
                        </div>
                        <div class="m-t-16 d-flex" v-if="status==='1'">
                            <div class="form-group mod flex-1">
                                <label for="waktu_masuk" class="form-label">Waktu Masuk</label>
                                <input type="time" class="form-control" id="waktu_masuk"
                                       v-model="time_awal" @change="cekvalidatemodal">
                            </div>
                            <div class="m-l-8 form-group mod flex-1">
                                <label for="waktu_pulang" class="form-label">Waktu Pulang</label>
                                <input type="time" class="form-control" id="waktu_pulang"
                                       v-model="time_akhir" @change="cekvalidatemodal">
                            </div>
                        </div>

                        <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                            <button class="btn smart-primary" id="BtnDetailAbsen" disabled @click="UpdateStatus">Simpan</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DetailAbsenPenggajian",
        data(){
            return{
                Date_rekap:'',
                Date_post:'',
                status:0,
                masuk_kerja:'',
                pulang_kerja:'',
                Data_Detail:[],
                time_awal:'',
                time_akhir:'',
                idlokasi:'',
                lokasi:0,
                idkaryawan:'',
                selectedabsen:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        props:['datarekapdetail','datarekap'],
        mounted() {
            this.gettimetoday();
            this.timenow();
            this.GetDetailAbsensiz();
            this.timenowakhir();
            this.gettimetodayakhir();
            this.cekvalidatemodal();
        },
        methods:{
            buttonKemarin() {
                var d = new Date(this.datarekapdetail.tanggal);
                d.setDate(d.getDate() - 1);
                var theDateReduced = d.toLocaleDateString('ja', {
                    year:  'numeric',
                    month: '2-digit',
                    day:   '2-digit'
                }).replace(/\//g, '-')
                this.datarekapdetail.tanggal=theDateReduced
                this.GetDetailAbsensiz();
            },
            buttonBesok() {
                var d = new Date(this.datarekapdetail.tanggal);
                d.setDate(d.getDate() + 1);
                var theDateReduced = d.toLocaleDateString('ja', {
                    year:  'numeric',
                    month: '2-digit',
                    day:   '2-digit'
                }).replace(/\//g, '-')
                this.datarekapdetail.tanggal=theDateReduced
                this.GetDetailAbsensiz();

            },

            backrekapabsen(){
                // var idkaryawan = this.datarekap.idkaryawan;
                this.$emit('showubahabsensi')
            },

            cekvalidatemodal(){
                this.status = this.selectedabsen;
                var selectLayanan = this.time_awal;
                var selectLayanan1 = this.time_akhir;
                var selectLayanan2 = this.selectedabsen;
                console.log(this.status);
                if (selectLayanan !== '' && selectLayanan1 >= selectLayanan && selectLayanan2 !=='') {
                    $('#BtnDetailAbsen').prop('disabled', false);
                } else {
                    $('#BtnDetailAbsen').prop('disabled', true);
                }
            },


            gettimetoday(){
                $('#waktu_masuk').attr('min',this.time_awal);
            },

            timenow(){
                var today = new Date();
                var HH = today.getHours();
                var minutes = today.getMinutes()
                if(minutes < 10) {
                    minutes = "0" + minutes
                }

                if(HH < 10) {
                    HH = "0" + HH
                }

                today =  HH +':'+ minutes;
                this.time_awal = today;
            },

            gettimetodayakhir(){
                $('#waktu_pulang').attr('max',this.time_akhir);
            },

            timenowakhir(){
                var today = new Date();
                var HH = today.getHours();
                var minutes = today.getMinutes()
                if(minutes < 10) {
                    minutes = "0" + minutes
                }

                if(HH < 10) {
                    HH = "0" + HH
                }

                today =  HH +':'+ minutes;
                this.time_akhir = today;
            },


            async GetDetailAbsensiz(){

                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                this.Data_Detail=[];
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_absensi_tanggal?idkaryawan=' + this.datarekapdetail.idkaryawan + '&tanggalMasuk=' + this.datarekapdetail.tanggal, this.requestHeaders);
                    if (res.status === 200) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var DataKaryawan = res.data.data;
                        this.Date_rekap = DataKaryawan.tanggal_absen_format;
                        this.Date_post = DataKaryawan.tanggal_absen;
                        var status = DataKaryawan.status;
                        this.status =  status.toString();
                        this.masuk_kerja = DataKaryawan.masuk;
                        this.pulang_kerja = DataKaryawan.pulang;
                        this.selectedabsen = DataKaryawan.status;
                        this.lokasi = DataKaryawan.lokasi;
                        this.idkaryawan = DataKaryawan.idkaryawan;
                        if(this.status==='0'){
                            $('#tanpa_status').show();
                        }else{
                            $('#tanpa_status').hide();
                        }

                    }
                } catch (e) {
                    if (!e.code) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#alert').show()
                        $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        setTimeout(() => {
                            $('#alert').removeClass("alert alert-danger animated fadeInDown");
                            $('#alert').addClass("alert alert-danger animated fadeOutUp");
                        }, 30000)
                        if (e.response.status === 500) {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#alert').show()
                            $('#contentAlert').text(e.response.data.msg);
                            $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                            $('#alert').addClass("alert alert-danger animated fadeInDown");
                            $('#close').show()
                        }
                    }
                }
            },

            async UpdateStatus(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const UpdateAbsen = new FormData;
                    UpdateAbsen.append('idkaryawan', this.idkaryawan);
                    UpdateAbsen.append('lokasi', this.lokasi);
                    UpdateAbsen.append('idlokasi', this.datarekapdetail.idlokasi);
                    UpdateAbsen.append('tanggal_absen', this.Date_post);
                    UpdateAbsen.append('waktu_masuk', this.time_awal + ':00');
                    UpdateAbsen.append('waktu_keluar', this.time_akhir + ':00');
                    UpdateAbsen.append('status_absensi', this.selectedabsen);
                    const res = await this.$axios.post(this.$baseurl + '/masterData/karyawan/update_status_absen_karyawan',UpdateAbsen,this.requestHeaders);
                    if (res.status === 200) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.GetDetailAbsensiz();
                        $('#modalnotif').modal('hide');
                    }
                } catch (e) {
                    if (!e.code) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#alert').show()
                        $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        setTimeout(() => {
                            $('#alert').removeClass("alert alert-danger animated fadeInDown");
                            $('#alert').addClass("alert alert-danger animated fadeOutUp");
                        }, 30000)
                        if (e.response.status === 500) {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#alert').show()
                            $('#contentAlert').text(e.response.data.msg);
                            $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                            $('#alert').addClass("alert alert-danger animated fadeInDown");
                            $('#close').show()
                        }
                    }
                }
            },

        }
    }
</script>


<style scoped>
    .nav-bottom-wrapper {
        position: fixed;
        width: 100%;
        bottom: 72px;
        background: white;
        box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.05);
    }
    .absensi-noted-by {
        color: #6F7287;
        font-size:12px;
        padding-top: 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid #EDEDED;
    }
</style>